import { getTranText2 } from 'src/_helpers'
export const ClientForm = ({ type, clientInfo }) => {
  return <>
    {(type <= 3 || clientInfo.customer_name) && <><div className="message stark">
      {getTranText2('CHAT_TEXT_1')}
    </div>
      {clientInfo.customer_name && <div className="message parker">
        {clientInfo.customer_name}
      </div>}
    </>}
    {((type <= 3 && type >= 2) || clientInfo.customer_phone) && <><div className="message stark">
      {getTranText2('CHAT_TEXT_2')}
    </div>
      {clientInfo.customer_phone && <div className="message parker">
        {clientInfo.customer_phone}
      </div>}</>}
    {clientInfo.customer_name && clientInfo.customer_phone && clientInfo.status === 'DONE' && <div className="message stark">
      <span
        dangerouslySetInnerHTML={{
          __html: getTranText2('CHAT_TEXT_3').replace("{client_name}", clientInfo.customer_name)
        }}
      />
    </div>}
  </>;
};
